import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { PhoneCall, Menu, X } from "lucide-react";
import logoImg from "../assets/logo.jpg"; 

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Products", path: "/products" },
    { name: "Technical", path: "/technical" },
    { name: "Gallery", path: "/gallery" },
    { name: "Contact", path: "/contact" },
  ];

  const handleMobileClick = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-[#4B3621]/90 backdrop-blur-md border-b border-white/10 shadow-lg">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        
        <Link to="/" className="flex items-center gap-3 group">
          <img 
            src={logoImg} 
            alt="Guru's Logo" 
            className="h-14 w-auto object-contain transition-transform duration-500 group-hover:scale-105" 
          />
          <div className="flex flex-col justify-center border-l border-white/20 pl-3">
            <span className="text-2xl font-black text-white tracking-tighter leading-tight flex items-center gap-1">
              GURU'S
            </span>
            <span className="text-[9px] font-bold text-[#D4AF37] tracking-[0.15em] uppercase whitespace-nowrap leading-none">
              Fresh Sheep Meat & Poultry Farm
            </span>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-8 lg:gap-10">
          {navLinks.slice(0, 4).map((link) => (
            <NavLink
              key={link.name}
              to={link.path}
              className={({ isActive }) =>
                `text-[10px] font-bold uppercase tracking-[0.2em] transition-all duration-300 relative py-2
                ${isActive 
                  ? "text-[#D4AF37] after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-[#D4AF37]" 
                  : "text-white/80 hover:text-white"
                }`
              }
            >
              {link.name}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <Link
            to="/contact"
            className="hidden sm:flex group relative items-center gap-3 bg-[#D4AF37] text-[#2D3A20] px-6 py-2.5 rounded-full font-black text-[10px] uppercase tracking-widest transition-all duration-300 hover:bg-white hover:scale-105 shadow-lg active:scale-95"
          >
            <span>Inquire Now</span>
            <PhoneCall size={12} className="group-hover:rotate-12 transition-transform" />
          </Link>
          
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white hover:text-[#D4AF37] transition-colors p-2"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      <div className={`md:hidden absolute w-full bg-[#FDFCF8] transition-all duration-300 ease-in-out ${
        isMenuOpen 
          ? "max-h-screen opacity-100 shadow-2xl border-b border-[#4B3621]/10" 
          : "max-h-0 opacity-0 overflow-hidden"
      }`}>
        <div className="px-8 py-10 flex flex-col gap-6">
          {navLinks.map((item) => (
            <button 
              key={item.name} 
              onClick={() => handleMobileClick(item.path)}
              className="text-left text-[11px] uppercase font-black tracking-[0.3em] text-[#4B3621] pb-4 border-b border-[#4B3621]/5 hover:text-[#D4AF37] transition-colors"
            >
              {item.name}
            </button>
          ))}
          
          <button 
            onClick={() => handleMobileClick("/contact")}
            className="mt-4 flex items-center justify-center gap-3 bg-[#2D5A27] text-white py-4 rounded-xl font-black text-[10px] uppercase tracking-widest"
          >
            <PhoneCall size={14} /> Quick Inquiry
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;